// extracted by mini-css-extract-plugin
module.exports = {"RV-F":"F_RV-F__BYD70"};